<template>
  <el-dialog
    id="GLAModal"
    :title="$t('coach.leader.gla.assessmentFor', {leader: leader.full_name})"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <div
      v-if="!notCertified"
      class="notice"
    >
      <div class="content mainDesc">
        <div class="desc">
          {{ $t('coach.leader.gla.description1') }}
        </div>

        <div class="desc">
          {{ $t('coach.leader.gla.description2') }}
        </div>
      </div>

      <el-radio-group v-model="needAssessment">
        <el-radio :label="true">
          {{ $t('coach.leader.gla.doLaunch') }}
        </el-radio>
        <el-radio :label="false">
          {{ $t('coach.leader.gla.doCancel') }}
        </el-radio>
      </el-radio-group>

      <div class="asteriskHint">
        *{{ $t('coach.leader.gla.noExtra') }}
      </div>
    </div>

    <div
      v-else
      class="notice"
    >
      <div class="content">
        {{ $t('coach.leader.gla.alreadyCert') }}
      </div>
      <br />
      <div class="content">
        {{ $t('coach.leader.gla.startCert') }}
      </div>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-if="!notCertified"
        type="secondary"
        round
        @click="showLocal = false"
      >
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        v-if="!notCertified"
        v-loading="loading"
        :disabled="needAssessment === null"
        type="primary"
        round
        @click="submit"
      >
        <span>
          {{ $t('common.submit') }}
        </span>
      </el-button>

      <el-button
        v-if="notCertified"
        v-loading="loading"
        type="primary"
        round
        style="width: 175px;"
        @click="goToCertification"
      >
        <span>
          {{ $t('coach.leader.gla.getCert') }}
        </span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api';
import dialog from '@/mixins/dialog';
import { mapState } from 'vuex';

export default {
  name: 'GLAModal',

  mixins: [dialog],

  props: {
    leader: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    needAssessment: null,
    notCertified: false,
    loading: false,
  }),

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  methods: {
    async submit() {
      try {
        this.loading = true;
        const response = await api.saveLeaderGLA(this.leader.uuid, {
          off_platform: !this.needAssessment,
        });
        this.leader.gla_uuid = response.data.gla_uuid;
        this.showLocal = false;
        if (this.needAssessment && this.needAssessment !== 'off_platform') {
          window.open(`${process.env.VUE_APP_GLA_CLIENT}/dashboard/assessment/${response.data.gla_uuid}`, '_blank');
        }
      } catch (err) {
        console.log(err);
        if (err.msg) {
          if (err.msg === 'gla_not_certified') {
            this.notCertified = true;
          } else {
            this.$message.error(err.msg);
          }
        }
      } finally {
        this.loading = false;
      }
    },

    goToCertification() {
      let link = 'https://gla-360.com/certification/';
      if (this.user.user.contact_id) {
        link = `https://learn.globalcoachgroup.com/?memb_autologin=yes&auth_key=iso6k7usdbPC&Id=${this.user.user.contact_id}~&Email=${this.user.user.email}&redir=/courses/gla/`;
      }

      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  #GLAModal {
    text-align: left;

    .el-dialog {
      max-width: 550px;
    }

    .notice {
      margin-bottom: 10px;
      word-break: break-word;

      .mainDesc {
        .desc {
          width: 100%;
          padding: 10px 0;
        }
      }

      .asteriskHint {
        color: #858585;
        font-size: 12px;
        font-style: italic;
        padding-top: 20px;
      }

      div {
        font-size: 16px;
        color: #303133;
      }

      .el-radio-group {
        margin-top: 25px;
        margin-left: 25px;
      }
    }
  }
</style>

<style lang="scss">
  #GLAModal {
    .el-dialog__header {
      padding-top: 25px;
    }

    .el-dialog__body {
      padding: 20px 20px 0;
    }

    .el-dialog__footer {
      text-align: center;
      padding-top: 20px;
      padding-bottom: 30px;

      .el-button {
        width: 100px;
        padding: 13px 0;
      }
    }

    .el-radio {
      display: flex;
      color: #303133;
      margin-bottom: 15px;

      .el-radio__label {
        word-break: break-word;
        white-space: normal;
        font-size: 16px;
      }
    }
  }
</style>
